// src/components/MessageDisplay.js
import React from 'react';
import { formatDateTime, truncateText, isImage, isVideo, isAudio } from '../utils/appUtils';

function MessageDisplay({ messages, expandedMsgs, toggleExpanded }) {

    const renderMedia = (msg) => {
        if (!msg.mediaUrl) return null;
        return (
            <div className="wappsync-message__media-container"> {/* Renamed for clarity */}
                {isImage(msg.mediaUrl) && (
                    <img src={msg.mediaUrl} alt={msg.mediaName || 'media'} className="wappsync-media" />
                )}
                {isVideo(msg.mediaUrl) && (
                    <video controls src={msg.mediaUrl} className="wappsync-media" />
                )}
                {isAudio(msg.mediaUrl) && (
                    <audio controls src={msg.mediaUrl} className="wappsync-media wappsync-media--audio" />
                )}
            </div>
        );
    };

    const renderMessage = (msg) => {
        const isExpanded = expandedMsgs.has(msg.id);
        const bodyText = msg.message || msg.text || ''; // Ensure bodyText is always a string
        const textToShow = isExpanded ? bodyText : truncateText(bodyText);
        const shouldShowToggle = bodyText.length > 80; // Apply truncation based on bodyText

        // Assume msg.title exists, or fallback to a default/truncated message if needed
        const messageTitle = msg.title || truncateText(bodyText, 50); // Fallback title from body if no explicit title

        return (
            <li key={msg.id} className="wappsync-message">
                <div className="wappsync-message__header">
                    <div className="wappsync-message__timestamp">
                        {formatDateTime(msg.timestamp)}
                    </div>
                    {messageTitle && (
                        <h3 className="wappsync-message__title">
                            {messageTitle}
                        </h3>
                    )}
                </div>

                {renderMedia(msg)} {/* Render media first if it's visually part of the header/above body */}

                {bodyText && ( // Only render body if it exists
                    <div className="wappsync-message__body">
                        {textToShow}
                        {shouldShowToggle && (
                            <button
                                onClick={() => toggleExpanded(msg.id)}
                                className="wappsync-message__toggle"
                            >
                                {isExpanded ? 'Less' : 'More'}
                            </button>
                        )}
                    </div>
                )}
            </li>
        );
    };

    return (
        <>
            {messages.length === 0 && (
                <div className="wappsync-no-messages">No messages yet.</div>
            )}
            {messages.length > 0 && (
                <ul className="wappsync-messages-list">
                    {messages.map(renderMessage)}
                </ul>
            )}
        </>
    );
}

export default MessageDisplay;